export const TITLE_VARIANTS = {
  h1: "h1-title",
  h2: "h2-title",
  h3: "h3-title",
  h4: "h4-title",
  h5: "h5-title",
  h6: "h6-title",
} as const;

export const SKELETON_VARIANTS = {
  h1: "h1-skeleton",
  h2: "h2-skeleton",
  h3: "h3-skeleton",
  h4: "h4-skeleton",
  h5: "h5-skeleton",
  h6: "h6-skeleton",
} as const;
